export default __webpack_public_path__ + "static/media/Tabl_1.d8e11975.svg";